import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { assetIcons } from "../../constants/assets";
import useWindowWidth from "../../hooks/window-size/use-window-width";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: "#fff",
  height: 40,
  width: 40,
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.8)", // white with 50% opacity
  },
}));

const SocialIconsWithText = ({ text, onIconClick, isMobile }) => {
  const windowWidth = useWindowWidth();

  const isTablet = windowWidth < 1288;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isMobile ? "center" : "left",
        alignItems: "center",
        gap: 1,
      }}
    >
      {/* {!isTablet && ( */}
      <Typography
        fontSize="clamp(12px, 1vw, 16px)"
        textAlign={"left"}
        fontWeight={600}
        sx={{ px: 1 }}
      >
        {text}
      </Typography>
      {/* )} */}

      <Box sx={{ display: "flex", gap: 1 }}>
        <StyledIconButton onClick={() => onIconClick("google")}>
          <img src={assetIcons.google} alt="google" />
        </StyledIconButton>
      </Box>
    </Box>
  );
};

export default SocialIconsWithText;
